import React from 'react';
import { Lock } from 'lucide-react';

interface LockPillProps {
  size?: 'sm' | 'md';
  className?: string;
}

const LockPill: React.FC<LockPillProps> = ({ size = 'sm', className = '' }) => {
  const h = size === 'md' ? 'h-7' : 'h-6';
  const px = size === 'md' ? 'px-3.5' : 'px-3';
  const knob = size === 'md' ? 'w-4 h-4' : 'w-3.5 h-3.5';
  const lockSize = size === 'md' ? 'w-2.5 h-2.5' : 'w-2.5 h-2.5';

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    try { e.stopPropagation(); } catch {}
    try { window.dispatchEvent(new CustomEvent('sf-open-auth')); } catch {}
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Unlock access"
      className={[
        'inline-flex items-center rounded-full',
        h,
        px,
        'btn active',
        'border border-blue-500/60',
        'shadow-sm backdrop-blur-sm',
        'hover:bg-blue-600',
        'focus:outline-none focus:ring-2 focus:ring-blue-500',
        className,
      ].join(' ')}
    >
      <span className={[
        'flex items-center justify-center rounded-full',
        'active-bg',
        knob,
      ].join(' ')}>
        <Lock className={`${lockSize} `} />
      </span>
    </button>
  );
};

export default LockPill;
